/** @file orderNodes: node records in parent-first depth-first order (the pose contract's node order). */
import type { PuppetNode } from '@zilo/pose3d-format/types/puppet';

/**
 * A copy of `nodes` whose key order is depth-first from the roots, each parent before its children and siblings
 * in their existing relative key order; nodes no root reaches (a cycle) follow in key order.
 */
export function orderNodes(nodes: Readonly<Record<string, PuppetNode>>): Record<string, PuppetNode> {
  const names = Object.keys(nodes);
  const out: Record<string, PuppetNode> = {};
  const visit = (name: string): void => {
    const node = nodes[name];
    if (node === undefined || Object.hasOwn(out, name)) return;
    out[name] = node;
    for (const child of names) if (nodes[child]?.parent === name) visit(child);
  };
  for (const name of names) if (nodes[name]?.parent === undefined) visit(name);
  for (const name of names) visit(name);
  return out;
}
